import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";
import Navbar2 from "../components/Navbar2";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import Navbar from "../components/Navbar";
import NavbarMob from "../components/NavbarMob";
import Navbar2Mob from "../components/Navbar2Mob";

function EnableStaff() {
    const [staffData, setStaffData] = useState([]);
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || "";
    const navigate = useNavigate();
    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

    const [searchQuery, setSearchQuery] = useState({
        companyName: "",
        mobileNumber: "",
        email: "",
        address: "",
        customerType: "",
    });

    // Fetch staff list
    useEffect(() => {
        fetch(`${apiBaseUrl}/fetchallstaff`)
            .then((res) => {
                if (!res.ok) throw new Error(`Failed to load staff: ${res.status}`);
                return res.json();
            })
            .then((data) => {
                console.log("Full staff data received from server:", data); // ← most useful
                console.log("First staff item (if exists):", data[0]); // quick check structure
                console.log("Total staff count:", data.length);
                setStaffData(data);
            })
            .catch((err) => {
                console.error("Error loading staff:", err);
            });
    }, [apiBaseUrl]);

    const filteredStaffData = staffData.filter((staff) =>
        Object.keys(searchQuery).every((key) =>
            staff[key]?.toString().toLowerCase().includes(searchQuery[key].toLowerCase())
        )
    );

    const handleSearchChange = (e) => {
        const { name, value } = e.target;
        setSearchQuery((prev) => ({ ...prev, [name]: value }));
    };

    // Toggle Enable Job Post
    const toggleJobPost = async (staffId, currentValue, companyName) => {
        const newValue = currentValue === "on" ? "off" : "on";

        setStaffData((prev) => prev.map((s) => (s.staffId === staffId ? { ...s, power: newValue } : s)));

        try {
            const res = await fetch(`${apiBaseUrl}/updatepower`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    companyName, // ← changed
                    power: newValue,
                }),
            });

            const data = await res.json();
            if (!res.ok || !data.success) throw new Error(data.message || "Failed");
        } catch (err) {
            console.error(err);
            setStaffData((prev) => prev.map((s) => (s.staffId === staffId ? { ...s, power: currentValue } : s)));
            alert("Failed to update Job Post");
        }
    };

    // Toggle Special Power
    const toggleSpecialPower = async (staffId, currentValue, companyName) => {
        const newValue = currentValue === "on" ? "off" : "on";

        setStaffData((prev) => prev.map((s) => (s.staffId === staffId ? { ...s, specialPower: newValue } : s)));

        try {
            const res = await fetch(`${apiBaseUrl}/updatespecialpower`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    companyName, // ← changed
                    specialPower: newValue,
                }),
            });

            const data = await res.json();
            if (!res.ok || !data.success) throw new Error(data.message || "Failed");
        } catch (err) {
            console.error(err);
            setStaffData((prev) => prev.map((s) => (s.staffId === staffId ? { ...s, specialPower: currentValue } : s)));
            alert("Failed to update Special Power");
        }
    };

    // Toggle Enable Package
    const toggleEnablePackage = async (staffId, currentValue, companyName) => {
        const newValue = currentValue === "on" ? "off" : "on";

        // Optimistic update
        setStaffData((prev) => prev.map((s) => (s.staffId === staffId ? { ...s, enablePackage: newValue } : s)));

        try {
            const res = await fetch(`${apiBaseUrl}/updateEnablepackage`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    companyName,
                    enablePackage: newValue,
                }),
            });

            const data = await res.json();

            if (!res.ok || !data?.success) {
                throw new Error(data?.message || "Update failed");
            }

            // ── MOST IMPORTANT PART ──
            // Re-fetch fresh data from server after successful update
            const freshResponse = await fetch(`${apiBaseUrl}/fetchallstaff`);
            const freshData = await freshResponse.json();
            setStaffData(freshData);

            console.log("Enable Package updated & list refreshed");
        } catch (err) {
            console.error("Failed to update enable package:", err);

            // Rollback
            setStaffData((prev) => prev.map((s) => (s.staffId === staffId ? { ...s, enablePackage: currentValue } : s)));

            alert("Could not update Enable Package. Please try again.");
        }
    };

    return (
        <div className="min-h-screen flex flex-col bg-gray-50">
            {isMobile ? <NavbarMob /> : <Navbar />}
            <div className="hidden md:block">
                <Navbar2 />
            </div>
            <div className="md:hidden">
                <Navbar2Mob />
            </div>

            <div className="flex-1 px-4 py-10 sm:px-8 lg:px-16">
                <h1 className="text-2xl md:text-3xl font-bold text-center text-gray-800 mb-8">Manage Staff Permissions</h1>

                <div className="overflow-x-auto rounded-lg shadow">
                    <table className="min-w-full divide-y divide-gray-200 bg-white">
                        <thead className="bg-blue-700 text-white">
                            <tr>
                                <th className="px-4 py-3 text-center  font-semibold">Staff Name</th>
                                <th className="px-4 py-3 text-center  font-semibold">Mobile</th>
                                <th className="px-4 py-3 text-center  font-semibold">Type</th>
                                <th className="px-4 py-3 text-center  font-semibold">Password</th>
                                <th className="px-4 py-3 text-center  font-semibold">Enable Job Post</th>
                                <th className="px-4 py-3 text-center  font-semibold">Special Power</th>
                                <th className="px-4 py-3 text-center  font-semibold">Enable Package</th>
                                <th className="px-4 py-3 text-center  font-semibold">Change Credentials</th>
                                {/* <th className="px-4 py-3 text-center text-sm font-semibold">Change Mobile</th> */}
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200">
                            {filteredStaffData.map((staff) => (
                                <tr key={staff.staffId} className="hover:bg-gray-50">
                                    <td className="px-4 py-3 text-sm font-medium text-gray-900">{staff.companyName}</td>
                                    <td className="px-4 py-3 text-sm text-gray-700">{staff.mobileNumber || "—"}</td>
                                    <td className="px-4 py-3 text-sm text-gray-700">{staff.customerType || "—"}</td>
                                    <td className="px-4 py-3 text-sm text-gray-700">{staff.password || "—"}</td>

                                    {/* Enable Job Post */}
                                    <td className="px-4 py-3 text-center">
                                        <button
                                            onClick={() => toggleJobPost(staff.staffId, staff.power, staff.companyName)}
                                            className={`px-6 py-2 rounded-md text-white font-medium min-w-[80px] transition ${
                                                staff.power === "on"
                                                    ? "bg-green-600 hover:bg-green-700"
                                                    : "bg-red-600 hover:bg-red-700"
                                            }`}
                                        >
                                            {staff.power === "on" ? "ON" : "OFF"}
                                        </button>
                                    </td>

                                    {/* Special Power */}
                                    <td className="px-4 py-3 text-center">
                                        <button
                                            onClick={() =>
                                                toggleSpecialPower(staff.staffId, staff.specialPower, staff.companyName)
                                            }
                                            className={`px-6 py-2 rounded-md text-white font-medium min-w-[80px] transition ${
                                                (staff.specialPower ?? "off") === "on"
                                                    ? "bg-green-600 hover:bg-green-700"
                                                    : "bg-red-600 hover:bg-red-700"
                                            }`}
                                        >
                                            {(staff.specialPower ?? "off") === "on" ? "ON" : "OFF"}
                                        </button>
                                    </td>

                                    {/* Enable Package – now separate */}
                                    <td className="px-4 py-3 text-center">
                                        <button
                                            onClick={() =>
                                                toggleEnablePackage(staff.staffId, staff.enablePackage, staff.companyName)
                                            }
                                            className={`px-6 py-2 rounded-md text-white font-medium min-w-[80px] transition ${
                                                (staff.enablePackage ?? "off") === "on"
                                                    ? "bg-green-600 hover:bg-green-700"
                                                    : "bg-red-600 hover:bg-red-700"
                                            }`}
                                        >
                                            {(staff.enablePackage ?? "off") === "on" ? "ON" : "OFF"}
                                        </button>
                                    </td>

                                    <td className="px-4 py-3 text-center">
                                        <div className="flex items-center justify-center gap-4">
                                            <button
                                                onClick={() => navigate(`/change-mobile/${staff.staffId}`)}
                                                className="text-blue-600 hover:text-blue-800 font-medium underline"
                                            >
                                                Change Mobile
                                            </button>
                                            <button
                                                onClick={() => navigate(`/change-password/${staff.staffId}`)}
                                                className="text-red-600 hover:text-red-800 font-medium underline"
                                            >
                                                Change Password
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            <Footer />
        </div>
    );
}

export default EnableStaff;
